<i18n>
{
  "en": {
  },
  "es": {
  }
}
</i18n>
<template>
  <router-view />
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

@Component
export default class ProductMaster extends Vue {
}
</script>
